<template>
  <div>
    <section
      v-if="tWaiting"
      class="hero"
      :class="{
        'is-warning': tWaiting.number <= 0,
        'is-primary': tWaiting.number > 0,
      }"
    >
      <div class="hero-body">
        <div v-if="tWaiting.number <= 0" class="container">
          <h1 class="title">
            Soy el siguiente en ser atendido
            <b-icon icon="alert-circle" size="is-medium" type="is-light"></b-icon>
          </h1>
          <h2 class="subtitle">
            Me llamarán pronto a mi número
            {{ tWaiting.phone }}
            <b-icon icon="cellphone" type="is-light"></b-icon>
          </h2>
        </div>
        <div v-else class="container">
          <h1 class="title">
            Mi turno virtual de atención es el {{ tWaiting.number }}
            <b-icon icon="account-multiple" size="is-medium" type="is-light"></b-icon>
          </h1>
          <h2 class="subtitle">
            Me llamarán al teléfono
            {{ tWaiting.phone }}
            <b-icon icon="cellphone" type="is-light"></b-icon>
          </h2>
        </div>
        <div class="container">
          <b-button @click="cancelarTicket(tWaiting.id)" type="is-warning">Cancelar Cita</b-button>
        </div>
      </div>
    </section>
    <section
      v-if="tWarning"
      class="hero"
      :class="{
        'is-warning': horasFaltantes <= 4,
        'is-success': horasFaltantes > 4,
      }"
    >
      <div class="hero-body">
        <div v-if="horasFaltantes <= 4" class="container">
          <h1 class="title titleWarning">
            Tengo que estar presente en la notaria dentro de
            <template
              v-if="horasFaltantes >= 1"
            >{{ horasFaltantes }} hs.</template>
            <template v-else>{{ minutos }} min.</template>
            <b-icon icon="alert" size="is-medium" type="is-light"></b-icon>
          </h1>
          <h2 class="subtitle">
            Tengo una cita a las
            <b-icon icon="alarm" type="is-light"></b-icon>
            {{ tWarning.pickupTime }}
            <br />Con
            <b-icon icon="account-tie" type="is-light"></b-icon>
            {{ tWarning.worker_id }}
            <br />Sobre el trámite
            <b-icon icon="text-box" type="is-light"></b-icon>
            {{ tWarning.sub_area_id }}
          </h2>
        </div>
        <div v-else class="container">
          <h1 class="title titleWarning" v-if="diasFaltantes >= 1">
            Tengo una cita a dentro de
            {{ diasFaltantes }} dia(s).
          </h1>
          <h1 class="title titleWarning" v-if="diasFaltantes < 1">
            Tengo que ir a la notaria dentro de
            {{ horasFaltantes }} hs.
          </h1>
          <h2 class="subtitle">
            Tiene una cita a las:
            <b-icon icon="alarm" type="is-light"></b-icon>
            {{ tWarning.pickupTime }}
            <br />Con
            <b-icon icon="account-tie" type="is-light"></b-icon>
            {{ tWarning.worker_id }}
            <br />Sobre el trámite:
            <b-icon icon="text-box" type="is-light"></b-icon>
            {{ tWarning.sub_area_id }}
          </h2>
        </div>
        <div class="container">
          <b-button @click="cancelarTicket(tWarning.id)" type="is-warning">Cancelar Cita Física</b-button>
        </div>
      </div>
    </section>
  </div>
</template>
<style lang="scss">
.titleWarning {
  font-size: 1.8rem !important;
}
</style>
<script>
export default {
  methods: {
    cancelarTicket(ticker_id) {
      this.$buefy.dialog.confirm({
        message: "Voy a cancelar mi cita.",
        cancelText: "No",
        confirmText: "Sí",
        onConfirm: () => {
          const form = new FormData();
          form.append("ticket_id", ticker_id);
          this.$http
            .post(this.$store.state.url + "/api/user/cancelarTicket", form, {
              headers: {
                Authorization: "Bearer " + this.$store.state.user.token
              }
            })
            .then(response => {
              console.log(response);
            });
        }
      });
    },
    callRank() {
      if (this.$store.state.login) {
        this.$http
          .post(
            this.$store.state.url + "/api/user/ticketState",
            {},
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.user.token
              }
            }
          )
          .then(r => {
            this.tWarning = r.data.success.ticketWarning;
            this.tWaiting = r.data.success.ticketWaiting;
            console.log(r);
            console.log(this.tWaiting);
            console.log("WARNING: ", this.tWarning);
            if (this.tWarning != null) {
              console.log("ENTRO: ", this.tWarning.minutes);
              this.minutos = this.tWarning.minutes;
              this.horasFaltantes = parseInt(this.minutos / 60);
              this.diasFaltantes = parseInt(this.horasFaltantes / 24);
            }
            if (this.tWarning != null || this.tWaiting != null) {
              this.$emit("tramiteActivo");
            }
            //   this.horasFaltantes = Math.trunc(
            //     Math.abs(new Date() - new Date(this.tWarning.pickupTime)) / 36e5
            //   );
            //   this.diasFaltantes = (this.horasFaltantes / 24).toFixed();
          });
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    this.callRank();

    this.interval = setInterval(() => this.callRank(), 10000);
  },
  data() {
    return {
      turnoActual: -1,
      tickets: {},
      tWarning: null,
      tWaiting: null,
      horasFaltantes: -1,
      diasFaltantes: -1,
      minutos: -1,
      interval: null
    };
  }
};
</script>
